<template>
    <div class="bg-black h-screen w-screen flex">
        <v-btn v-if="isLoggedIn && !leftSectionRouteDisabler" class="!absolute top-10 right-5 z-10 sm:!hidden"
            :color="colorAsRoute" :outlined="!navState" @click.prevent="$store.dispatch('premiumNav')" dark>
            <v-icon>{{ !navState ? 'mdi-menu' : 'mdi-close' }}</v-icon>
        </v-btn>
        <div class="">
            <NavDrawer v-if="!leftSectionRouteDisabler" />
        </div>
        <div :class="`w-full ${!leftSectionRouteDisabler ? 'container' : ''}  !p-0`">
            <!-- <main-section /> -->
            <v-avatar width="100%" v-if="isLoggedIn && !leftSectionRouteDisabler" height="90px" tile
                class="sm:!hidden mt-3">
                <v-img class="md:!max-w-[180px] !max-w-[130px] " :src="require('@/assets/img/Logo/logo.gif')" />
            </v-avatar>
            <router-view name="premium"></router-view>
        </div>
        
    </div>

    <!-- <h1 class="text-center text-black text-3xl mt-16">Under Maintainance</h1> -->
</template>
<script>
import MiniPlayer from '@/components/musicplayer/MiniPlayer.vue'
import NavDrawer from '../../components/premium/NavDrawer.vue'
import MainSection from '@/components/premium/MainSection.vue'
export default {
    components: {
        NavDrawer,
        MainSection,
        MiniPlayer
    },
    data: () => ({
        navDrawerClosed: true,
        userInteraction:false,
    }),
    computed: {
        spotifyVisibility() {
            return this.$store.getters.SpotifyPlayerVisibility;
        },
        premium() {
            return this.$store.getters.isPremium;
        },
        colorAsRoute() {
            if (this.routeLink == 'straight') {
                return '#a07a1d'
            }
            else if (this.routeLink == 'gay') {
                return '#88c3fa'
            }
            else if (this.routeLink == 'lesbian') {
                return '#9e2eec'
            }
        },
        navState() {
            return this.$store.getters.premiumNav;
        },
        leftSectionRouteDisabler() {
            return (
                this.$route.name === "Plan" ||
                this.$route.name === "Interest" ||
                this.$route.name === "Login" ||
                this.$route.name === "Register" ||
                this.$route.name === "Verify" ||
                this.$route.name === "Completeprofile" ||
                this.$route.name === "Notfound" ||
                this.$route.name === "Forgotpassword"
            );
        },
    },
    mounted() {
    if (this.$store.getters.SpotifyAccessToken) {
      document.addEventListener("click", () => {
        this.userInteraction = true;
      });
    }else{
      this.userInteraction = true;
    }
  }
}
</script>